module.exports = __webpack_public_path__ + "media/images/icon_a1_blue-15380c6f63248a5a14e10ccec9ac7240.png";